import React from "react";

import {
  OriginThemeProvider,
  TrackingProvider,
} from "@origin-digital/ods-core";
import { FeatureProvider } from "@origin-digital/features";
import { trackingProviderCaptureClick } from "@origin-digital/reporting-client";
import { AppContextProvider } from "src/context/AppContext";

import { Root } from "src/root";
import { UserContextProvider } from "@origin-digital/sales-common";
import { ToggleContextProvider } from "@origin-digital/toggle";
import { config } from "./config";
import { LoadKasadaIntegration } from "./LoadKasadaIntegration";
import { EnergyAddressLookupProvider } from "@origin-digital/sales-energy-address-lookup";

const FeatureProviderTyped: any = FeatureProvider;

const appAssetName = "movers-wpassets/movers-wp";

export default () => (
  <OriginThemeProvider>
    <FeatureProviderTyped
      config={(window as any)?.oetal?.config[appAssetName]?.toggle}
    >
      <LoadKasadaIntegration />
      <ToggleContextProvider appName={appAssetName} toggles={config.toggle}>
        <AppContextProvider>
          <UserContextProvider>
            <EnergyAddressLookupProvider config={config.addressApiProps}>
              <TrackingProvider
                onTrackingCapture={trackingProviderCaptureClick}
              >
                <Root />
              </TrackingProvider>
            </EnergyAddressLookupProvider>
          </UserContextProvider>
        </AppContextProvider>
      </ToggleContextProvider>
    </FeatureProviderTyped>
  </OriginThemeProvider>
);
